var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashBoardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1142_11455)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0098 48C37.2646 48 48.0098 37.2548 48.0098 24C48.0098 10.7452 37.2646 0 24.0098 0C10.7549 0 0.00976562 10.7452 0.00976562 24C0.00976562 37.2548 10.7549 48 24.0098 48Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1142_11455)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1142_11455",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 33,
    height: 32
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1348 36.6663H15.8848C15.3876 36.6658 14.911 36.4655 14.5595 36.1093C14.208 35.753 14.0103 35.2701 14.0098 34.7663V13.233C14.0103 12.7293 14.208 12.2463 14.5595 11.8901C14.911 11.5339 15.3876 11.3335 15.8848 11.333H32.1348C32.6319 11.3335 33.1085 11.5339 33.46 11.8901C33.8115 12.2463 34.0092 12.7293 34.0098 13.233V34.7663C34.0092 35.2701 33.8115 35.753 33.46 36.1093C33.1085 36.4655 32.6319 36.6658 32.1348 36.6663ZM16.5098 13.8663V34.133H31.5098V13.8663H16.5098ZM23.3848 30.333H19.6348C19.4691 30.3327 19.3103 30.2659 19.1931 30.1472C19.076 30.0285 19.01 29.8676 19.0098 29.6997V28.433C19.01 28.2651 19.076 28.1042 19.1931 27.9855C19.3103 27.8668 19.4691 27.7999 19.6348 27.7997H25.2598V28.433C25.2592 28.9368 25.0615 29.4197 24.71 29.7759C24.3585 30.1321 23.8819 30.3325 23.3848 30.333ZM28.3848 25.2663H19.6348C19.4691 25.2661 19.3103 25.1993 19.1931 25.0805C19.076 24.9618 19.01 24.8009 19.0098 24.633V23.3663C19.01 23.1985 19.076 23.0375 19.1931 22.9188C19.3103 22.8001 19.4691 22.7333 19.6348 22.733H28.3848C28.5504 22.7333 28.7093 22.8001 28.8264 22.9188C28.9436 23.0375 29.0095 23.1985 29.0098 23.3663V24.633C29.0095 24.8009 28.9436 24.9618 28.8264 25.0805C28.7093 25.1993 28.5504 25.2661 28.3848 25.2663ZM28.3848 20.1997H19.6348C19.4691 20.1994 19.3103 20.1326 19.1931 20.0139C19.076 19.8952 19.01 19.7342 19.0098 19.5663V18.2997C19.01 18.1318 19.076 17.9709 19.1931 17.8521C19.3103 17.7334 19.4691 17.6666 19.6348 17.6663H28.3848C28.5504 17.6666 28.7093 17.7334 28.8264 17.8521C28.9436 17.9709 29.0095 18.1318 29.0098 18.2997V19.5663C29.0095 19.7342 28.9436 19.8952 28.8264 20.0139C28.7093 20.1326 28.5504 20.1994 28.3848 20.1997Z",
    fill: "#E87722"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1142_11455)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.00977,
    y: 8,
    width: 32,
    height: 32,
    fill: "#E87722"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1142_11455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.00976562)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1142_11455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8.00977 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashBoardIcon);
export default __webpack_public_path__ + "static/media/dash-board-icon.4aeb6f58bfb87b460de12d2fbc4757ca.svg";
export { ForwardRef as ReactComponent };